import React, { useEffect, useRef } from "react";
import main from "../../../images/sav/main.jpg";
import { FiPhone, FiMail } from "react-icons/fi";

export default function Service({navigateWithTransition}) {
const sectionRef = useRef(null);
useEffect(() => {
  const section = sectionRef.current;
  if (!section) return;

  const elements = section.querySelectorAll(".reveal-on-scroll");

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -8% 0px",
    }
  );

  elements.forEach((el) => revealObserver.observe(el));

  return () => revealObserver.disconnect();
}, []);


 return (
    <div className="garantie-page" ref={sectionRef}>
      <div className="top-section">
        <h1 className="reveal-on-scroll reveal-soft">À votre écoute, même après l'installation</h1>

       <p className="intro reveal-on-scroll reveal-soft delay-1">
          Chez <span>ELEMENTS GROUP</span>, notre service après-vente vous accompagne après 
l’installation de votre cuisine grâce à une assistance professionnelle, un suivi 
personnalisé et une maintenance de qualité pour garantir la durabilité de vos 
équipements.
        </p>

    
      
      </div>

      <div className="bottom-section">
       <div className="assistance-image reveal-on-scroll reveal-left">
          <img
            src={main}
            alt="Service"
          />

         
        </div>

       <div className="contact-box reveal-on-scroll reveal-right">
          <p className="subtitle">UN NUMÉRO UNIQUE</p>

          <h2>POUR VOUS SERVIR</h2>

       <div className="contact-info">
  <a href="tel:+21629067840" className="info-item">
    <FiPhone className="icon" />
    <span>29 067 840</span>
  </a>

  <a href="mailto:cdr@elements.tn" className="info-item">
    <FiMail className="icon" />
    <span>cdr@elements.tn</span>
  </a>
</div>
        </div>
      </div>
    </div>
  );

}